'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "ToolbarToggleButton", {
    enumerable: true,
    get: function() {
        return ToolbarToggleButton;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _reactbutton = require("@fluentui/react-button");
const _useToolbarToggleButton = require("./useToolbarToggleButton");
const _useToolbarToggleButtonStylesstyles = require("./useToolbarToggleButtonStyles.styles");
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const ToolbarToggleButton = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useToolbarToggleButton.useToolbarToggleButton_unstable)(props, ref);
    (0, _useToolbarToggleButtonStylesstyles.useToolbarToggleButtonStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useToolbarToggleButtonStyles_unstable')(state);
    return (0, _reactbutton.renderToggleButton_unstable)(state);
});
ToolbarToggleButton.displayName = 'ToolbarToggleButton';
